import { find, get, includes, orderBy, reject } from 'lodash';
import { getCurrentClub } from '../clubs/selectors';

const getAssignments = (state) => orderBy(get(state, 'shop.assignments', []), 'created', 'desc');

export const getShopCategories = (state) => get(getCurrentClub(state), 'shopCategories', []);

export const isLoadingLandingPage = (state) => get(state, 'shop.isLoadingLandingPage', false);

export const hasLoadedLandingPage = (state) => get(state, 'shop.hasLoadingLandingPage', false);

export const getFeaturedProducts = (state) => {
  if (hasLoadedLandingPage(state)) {
    const productsByCategory = get(state, 'shop.featuredProducts', []);
    const assignments = getAssignments(state);
    return productsByCategory.map((category) => {
      const { products, ...otherProps } = category;
      return {
        ...otherProps,
        products: products.map((product) => ({
          ...product,
          assignment: find(assignments, { productId: product.id }),
        })),
      };
    });
  }

  return getShopCategories(state).map((category) => ({
    name: category,
    products: [],
  }));
};

export const getOverdueProducts = (state) => {
  const products = get(state, 'shop.overdueProducts', []);
  return products.map(({ assignments, ...product }) => ({
    ...product,
    assignment: find(orderBy(assignments, 'created', 'desc'), { productId: product.id }),
  }));
};

export const getLandingPageLoadingError = (state) => get(state, 'shop.landingPageLoadingError', {});

export const isLoadingCategoryPage = (state, category, page) =>
  includes(get(state, 'shop.currentlyLoadingCategoryPages', []), `${category}-${page}`);

export const hasLoadedCategoryPage = (state, category, page) =>
  includes(get(state, 'shop.loadedCategoryPages', []), `${category}-${page}`);

export const getCategoryPageLoadingError = (state, category, page) =>
  find(get(state, `shop.categoryLoadingErrors`, []), { category, page });

export const getCategoryPagination = (state, category) =>
  get(state, `shop.categoryPagination[${category}]`);

export const getCategoryProducts = (state, category, page) => {
  const products = get(state, `shop.paginatedProductLists[${category}-${page}]`, []);
  const assignments = getAssignments(state);
  return products.map((product) => ({
    ...product,
    assignment: find(assignments, { productId: product.id }),
  }));
};

export const getProductPageLoadingError = (state, productId) =>
  find(get(state, `shop.productLoadingErrors`, []), { productId });

export const getProductPageData = (state, productId) => {
  const pageData = get(state, `shop.productPages[${productId}]`, {});
  const assignments = getAssignments(state);
  return {
    ...pageData,
    assignment: find(assignments, { productId }),
  };
};

export const hasLoadedProductPage = (state, productId) =>
  includes(get(state, 'shop.loadedProductPages', []), productId);

export const isLoadingProductPage = (state, productId) =>
  includes(get(state, 'shop.currentlyLoadingProducts', []), productId);

export const hasLoadedAssignments = (state) => get(state, 'shop.hasLoadedAssignments', false);

export const isLoadingAssignments = (state) => get(state, 'shop.isLoadingAssignments', false);

export const getRelatedProducts = (state, productId) => {
  const { category } = getProductPageData(state, productId);
  const { products = [] } = find(getFeaturedProducts(state), { name: category }) || {};
  return reject(products, { id: productId });
};

export const getShopBannerClosed = (state) => get(state, 'shop.bannerClosed', false);
